import { createContext } from 'react';

export const initialState = {
  refreshData: false,
};
const ControleOrdersContext = createContext(initialState);

export const { Provider } = ControleOrdersContext;
export default ControleOrdersContext;
